import * as React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import './date-selector.scss';
import { GreenCheckBox } from 'components/greenCheckboxes/greenCheckBox';

registerLocale('ko', ko);

interface Props {
  onChange: (date: Date) => void;
  inputName?: string;
  value?: Date;
  label?: string;
  height?: number;
  width?: string;
  placeholder?: string;
  todayButtonUse?: boolean;
  minDate?: Date;
  isMonthPicker?: boolean;
  isYearPicker?: boolean;
  hasDisabled?: boolean;
  disabled?: boolean;
  toggleDisable?: (value: boolean) => void;
}

const DateSelector: React.FunctionComponent<Props> = ({
  onChange,
  inputName,
  value = moment().toDate(),
  label,
  height = 40,
  width = '100%',
  placeholder,
  todayButtonUse = true,
  minDate,
  isMonthPicker = false,
  isYearPicker = false,
  hasDisabled = false,
  disabled = false,
  toggleDisable,
}) => {
  const [DISABLED, setDISABLED] = React.useState<boolean>(disabled);
  const selectedValue = (date: Date) => {
    onChange(date);
  };

  const setDisabledInput = (value: boolean) => {
    setDISABLED(value);
    if (toggleDisable) toggleDisable(!value);
  };

  const ref = React.useRef() as any;

  document.documentElement.style.setProperty('--height', `${height}px`);
  document.documentElement.style.setProperty('--width', `${width}`);

  React.useEffect(() => {
    setDISABLED(disabled);
  }, [disabled]);

  const ExampleCustomInput = React.forwardRef(({ value, onClick, onChange }: any, ref: any) => (
    <input
      value={value}
      className={'date-selector__custom-input'}
      onClick={onClick}
      onChange={onChange}
      ref={ref}
      placeholder={placeholder}
    />
  ));

  return (
    <div className="date-selector">
      {label && <div className="date-selector__label">{label}</div>}
      <div className="date-selector__container">
        <div style={{ width: '100%', position: 'relative' }}>
          <DatePicker
            selected={value}
            onChange={selectedValue}
            customInput={<ExampleCustomInput />}
            dateFormat={isYearPicker ? 'yyyy년' : isMonthPicker ? 'yyyy년 M월' : 'yyyy.MM.dd'}
            name={inputName}
            locale={'ko'}
            disabledKeyboardNavigation
            todayButton={todayButtonUse ? (isYearPicker ? '올해' : isMonthPicker ? '이번달' : '오늘') : ''}
            minDate={minDate}
            showYearDropdown
            dropdownMode="select"
            withPortal
            showMonthYearPicker={isMonthPicker}
            showYearPicker={isYearPicker}
            disabled={DISABLED}
          />
          {hasDisabled && DISABLED && <div className="disableCover" />}
        </div>
        {hasDisabled && (
          <div className="disableButtonContainer">
            <GreenCheckBox onCheck={setDisabledInput} defaultValue={DISABLED} text={'미정'} />
          </div>
        )}
      </div>
    </div>
  );
};
export default DateSelector;
